/**
 * This mixin works in conjunction with the breakpoints mixin from GettyUI to make determine whether we're at a mobile breakpoint.
 */
import { breakpointsMixin, debounce } from "@thegetty-private/getty-ui";

export default {
  name: "MobileMixin",
  mixins: [breakpointsMixin],
  data() {
    return {
      /**
       * Whether or not current view is less than 768px
       */
      isMobile: false
    };
  },
  computed: {},
  mounted() {
    this.onResize();

    this.debouncedOnResize = debounce(this.onResize);
    window.addEventListener("resize", this.debouncedOnResize);
  },
  destroyed() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.debouncedOnResize);
    }
  },
  methods: {
    /**
     * Listener that sets itemsPerRow based on screen size
     */
    onResize() {
      this.isMobile = this.isSmallMinus();
    }
  }
};
